import React from 'react';
import Like from '../../../../assets/like.svg';
import DisLike from '../../../../assets/unlike.svg';
import { useDispatch } from 'react-redux';
import { hitDisLike, hitLike } from '../../../../features/video/videoSlice';


const LikeDislike = ({ id, likes, unlikes }) => {
    const dispatch = useDispatch();

    const hitLikes = (id) => {
        dispatch(hitLike({ id, likes }));
    }
    const hitDislikes = (id) => {
        dispatch(hitDisLike({ id, unlikes }));
    }

    return (
        <div className="flex gap-10 w-48">
            <div className="flex gap-1 items-center cursor-pointer" onClick={() => {
                hitLikes(id)
            }}>
                <div className="shrink-0">
                    <img
                        className="w-5 block"
                        src={Like}
                        alt="Like"
                    />
                </div>
                <div
                    className="text-sm leading-[1.7142857] text-slate-600"

                >
                    {likes}
                </div>
            </div>
            <div className="flex gap-1 items-center cursor-pointer" onClick={() => {
                hitDislikes(id)
            }}>
                <div className="shrink-0">
                    <img
                        className="w-5 block"
                        src={DisLike}
                        alt="Unlike"
                    />
                </div>
                <div
                    className="text-sm leading-[1.7142857] text-slate-600"
                >
                    {unlikes}
                </div>
            </div>
        </div>
    );
};

export default LikeDislike;